import { FC } from 'react';

import { AddressFinderAvailabilityStep } from '@eneco/flows/components';

import { ProductType, OrderType } from '../../types/types';

export const AddressStep: FC = () => (
  <AddressFinderAvailabilityStep
    contentName="SolarBoilerLeadFlowAddressStep"
    product={ProductType.EBoiler}
    orderType={OrderType.Installation}
    trackUnavailableNotification
  />
);
